import ajax from '@/lib/ajax'

/**
 * 获取-腹透外出口评估
 * @param payload {
 *      PD_Register_ID,
 *      PD_Patient_ID
 * }
 */
export async function GetPdAssessOutByRegister(payload: any) {
	let res = await ajax.get('/api/services/app/PDAssessOut/GetByRegister', {
		params: payload
	})
	return res.data.result
}
/**
 * 保存-腹透外出口评估
 * @param payload
 */
export async function SavePdAssessOut(payload: any) {
	let res = await ajax.post(`/api/services/app/PDAssessOut/Save`, payload)
	return res.data.result
}



// WEBPACK FOOTER //
// ./src/api/pdOutPatient/pdAssess/index.ts